import { render, staticRenderFns } from "./HowToUseACrucible.vue?vue&type=template&id=70c7c51e&scoped=true&"
import script from "./HowToUseACrucible.vue?vue&type=script&lang=js&"
export * from "./HowToUseACrucible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c7c51e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
